/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ set: NonNullable<unknown>, weight: NonNullable<unknown>, reps: NonNullable<unknown> }} Features_Set_ValuesInputs */

const en_features_set_values = /** @type {(inputs: Features_Set_ValuesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set ${i?.set} · ${i?.weight} kg × ${i?.reps}`)
};

const pl_features_set_values = /** @type {(inputs: Features_Set_ValuesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seria ${i?.set} · ${i?.weight} kg × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "Set {set} · {weight} kg × {reps}" |
*
* @param {Features_Set_ValuesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_set_values = /** @type {((inputs: Features_Set_ValuesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Set_ValuesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_set_values(inputs)
	return en_features_set_values(inputs)
});